import {createUseStyles} from 'react-jss';

export const useStyles = createUseStyles({
  footer: {
    fontSize: '12px',
    textAlign: 'center',
    marginTop: '20px',
  },
});
